import api from "./api";

export const getAllLevel4Resources = async () => {
  const { data } = await api.get("/admin/level4Resources");
  return data.level4Resources ?? [];
};
